import { render, staticRenderFns } from "./EditReplaceName.vue?vue&type=template&id=4d5c730a&scoped=true"
import script from "./EditReplaceName.vue?vue&type=script&lang=js"
export * from "./EditReplaceName.vue?vue&type=script&lang=js"
import style0 from "./EditReplaceName.vue?vue&type=style&index=0&id=4d5c730a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c730a",
  null
  
)

export default component.exports